<template>
  <div>

    <h1 style="font-size: 24px; color: black;">用户系统头像配置</h1>

    <div style="margin-bottom: 10px;">

      <table>
        <tr>
          <td>批量添加时，选择多个图片上传</td>
          <td>
            <el-upload :action="upload()"
                       :headers="headers"
                       :show-file-list="false"
                       :on-success="query"
                       multiple
                       v-loading.fullscreen.lock="loading">
              <el-button size="medium" type="primary">批量添加</el-button>
            </el-upload>
          </td>
        </tr>
      </table>
    </div>

    <div>
      <el-table border :data="heads">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="dtCreate" label="创建时间" :formatter="formatDate"></el-table-column>
        <el-table-column label="系统头像">
          <template slot-scope="scope">
            <template v-if="scope.row.head">
              <img :src="VUE_APP_CDN_URL+scope.row.head" width="80px" height="80px" alt=""/>
            </template>
            <template v-if="scope.row.size">
              {{ (scope.row.size / 1000).toFixed(2) }}kb
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.open"
                       :active-value=true
                       :inactive-value=false
                       active-text="开启"
                       inactive-text="关闭"
                       @change="update(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>

</template>

<script>

import {formatDate, queryHeads, updateHead} from "@/http/api";

export default {
  inject: ['reload'],
  name: "HeadList",
  data() {
    return {
      loading: false,
      VUE_APP_BASE_URL: null,
      VUE_APP_CDN_URL: null,
      uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
      head: {
        id: null,
        dtCreate: null,
        head: null,
        open: null
      },
      heads: null,
      headers: {}
    }
  },
  methods: {
    formatDate(row, column) {
      return formatDate(row, column);
    },
    query() {
      queryHeads().then(resp => {
        this.heads = resp.data.info;
        this.headers = {Authorization: this.$store.state.user.token};
      });
    },
    update(head) {
      updateHead(head);
    },
    upload() {
      return this.VUE_APP_BASE_URL + 'head/upload';
    },
  },
  created() {
    this.query();
  },
  mounted() {
    this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
  }
}
</script>

<style lang="less">
.sub {
  position: relative;
  left: 570px
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 60px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 60px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar1 {
  width: 150px;
  height: 200px;
  display: block;
}

.elalert {
  max-width: 89%;
  left: 11%;
}

.iconSize {
  font-size: 14px;
  font-weight: normal;
}

</style>
